import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Create a simple remote logging helper
const remoteLog = (message, data) => {
  try {
    fetch(process.env.REACT_APP_API_URL + '/debug/log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, data, timestamp: new Date().toISOString() })
    }).catch(() => {});
  } catch (e) {}
};

// Replace console.log with remote logging
const originalConsoleLog = console.log;
const originalConsoleError = console.error;

console.log = (...args) => {
  originalConsoleLog(...args);
  remoteLog('log', args);
};

console.error = (...args) => {
  originalConsoleError(...args);
  remoteLog('error', args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);